import { render } from "./ManageNewsListPage.vue?vue&type=template&id=c28a1886"
import script from "./ManageNewsListPage.vue?vue&type=script&lang=ts"
export * from "./ManageNewsListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script